import * as React from 'react';
import { SuburbanMortgageBanner } from '../../SuburbanComponents/SuburbanMortgageBanner';
import { useSelector } from 'react-redux';
import { selectMortgageBannerLink } from '../../selectors/suburban/selectMortgageBannerLink';

export const SuburbanMortgageBannerContainer = () => {
  const url = useSelector(selectMortgageBannerLink);

  if (!url) {
    return null;
  }

  return <SuburbanMortgageBanner url={url} />;
};
